module.exports = __webpack_public_path__ + "img/122.65968d05.jpg";